import { Textarea } from "@chakra-ui/react";
import { color as colorNames, radius } from "theme/names"

export const TextArea = ({ props }) => {
  return (
    <Textarea
      {...{
        borderRadius: radius.lg, // not being applied. to be investigated
        borderColor: colorNames.border.lightMode.light,
        _hover: {
          borderColor: colorNames.border.lightMode.hover,
        },
        _dark: {
          borderColor: "border.darkMode.light",
          color: "text.darkMode.standard",
          _hover: {
            borderColor: colorNames.border.darkMode.hover,
          },
        },
      }}
      variant={"taplio"}
      textStyle={"body.medium.standard"}
      fontSize="14px"
      transition="height none"
      w="100%"
      {...props}
      resize="none"
      colorScheme={"primaryChakraColorScheme"}
    />
  )
}